(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('.section-announcement-bar');
    const searches = document.querySelectorAll('.header__search details');
    if (!searches.length) return;
    let pending = false;
    const update = () => {
      pending = false;
      const bottom = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--bhg-search-top', bottom + 'px');
    };
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    };
    if (bar) new ResizeObserver(schedule).observe(bar);
    searches.forEach(search => search.addEventListener('toggle', update));
    window.addEventListener('resize', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
